module.exports = __webpack_public_path__ + "img/partners-active.e26ba9d9.svg";